import styled from 'styled-components';

const AboutUsWrapper = styled.div`
  margin: 0 4%;
  > * {
    font-family: "Avenir", "Arial", sans-serif;
  }
`;

export default AboutUsWrapper;
